import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { secretKey } from "../.././data";
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";
import { isArray } from "util";
import EditPelnSub from "./editPelnSub.js";
import SendPostTask from "./sendPostTask.js";

const MySwal = withReactContent(Swal2);

const AddLetterBank = (props) => {
  const [showEditPelnSub, setShowEditPelnSub] = useState(false);
  const [loading, setLoading] = useState(false);
  const [template, setTemplate] = useState("");
  const [templateName, setTemplateName] = useState("");
  const [task, setTask] = useState("");
  const [letters, setLetters] = useState([]);
  const [plnValue, setPlnValue] = useState(
    props.clientsData.wezwPlnValue === null
      ? 0
      : props.clientsData.wezwPlnValue.replaceAll(",", ".").replaceAll(" ", "")
  );
  const [chfValue, setChfValue] = useState(
    props.clientsData.wezwChfValue === null
      ? 0
      : props.clientsData.wezwChfValue.replaceAll(",", ".").replaceAll(" ", "")
  );
  const [lastPaymentDate, setLastPaymentDate] = useState(
    props.clientsData.wezwLastPayDate === null
      ? 0
      : props.clientsData.wezwLastPayDate
  );
  const [payTime, setPayTime] = useState(
    !props.clientsData.wezwPayTime ? "7 dni" : props.clientsData.wezwPayTime
  );
  const [koSkd, setKoSkd] = useState(
    props.clientsData.koSkd === null
      ? 0
      : props.clientsData.koSkd.replaceAll(",", ".").replaceAll(" ", "")
  );
  const [izrSkd, setIzrSkd] = useState(
    props.clientsData.izrSkd === null
      ? 0
      : props.clientsData.izrSkd.replaceAll(",", ".").replaceAll(" ", "")
  );
  const [irSkd, setIrSkd] = useState(
    props.clientsData.irSkd === null
      ? 0
      : props.clientsData.irSkd.replaceAll(",", ".").replaceAll(" ", "")
  );
  const [kpSkd, setKpSkd] = useState(
    props.clientsData.kpSkd === null
      ? 0
      : props.clientsData.kpSkd.replaceAll(",", ".").replaceAll(" ", "")
  );
  const [kupSkd, setKupSkd] = useState(
    props.clientsData.kupSkd === null
      ? 0
      : props.clientsData.kupSkd.replaceAll(",", ".").replaceAll(" ", "")
  );
  const [bank, setBank] = useState("");
  const [bankAddress, setBankAddress] = useState("");
  const [bankAddressDb, setBankAddressDb] = useState("");
  const [dateOpt, setDateOpt] = useState(
    props.clientsData.wezwLastPayDate === null ||
      props.clientsData.wezwLastPayDate === "całkowitej spłaty kredytu"
      ? "2"
      : "1"
  );
  const [lawyersData, setLawyersData] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [freeDays, setFreeDays] = useState([]);
  const [showSendPost, setShowSendPost] = useState(false);
  const [tasksWezw, setTasksWezw] = useState([]);
  const [usersSend5, setUsersSend5] = useState([]);

  const fetchBankAddress = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getBankAddress", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var arr = [];
        data.map((el) => {
          var data = "";

          if (el.addressNew) {
            data = JSON.parse(el.addressNew);
          } else {
            data = {
              street: "",
              number: "",
              postCode: "",
              city: "",
            };
          }

          var addressTxt =
            data.street +
            " " +
            data.number +
            ", " +
            data.postCode +
            " " +
            data.city;

          if (!el.addressNew) {
            addressTxt = "";
          }

          var obj = {
            id: el.id,
            nameSelect: el.nameSelect,
            nameLetter: el.nameLetter,
            bankKRS: el.bankKRS,
            address: addressTxt,
            addressNew: data,
          };

          arr.push(obj);
        });
        setBankAddressDb(
          arr.filter((el) => el.nameSelect === props.clientsData.bank)[0]
        );
        fetchLawyers();
      })
      .catch((error) => {});
  };

  const fetchLawyers = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getLawyers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLawyersData(data);
        fetchHolidays();
      })
      .catch((error) => {});
  };

  const fetchHolidays = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHolidays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHolidays(data.filter((el) => el.type === "holiday"));
        setLastPaymentDate(generateLastPayDate());
        fetchFreeDays();
      })
      .catch((error) => {});
  };

  const fetchFreeDays = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getFreeDays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setFreeDays(data);
        fetchLetters();
      })
      .catch((error) => {});
  };

  const fetchLetters = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getLettersBank", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLetters(data);
        setTemplate(data[0].link);
        fetchTasksWezw();
      })
      .catch((error) => {
        fetchTasksWezw();
      });
  };

  const fetchTasksWezw = async () => {
    var body = {
      id: props.clientsData.id,
    };

    await fetch(
      props.clientsData.type === "sankcja kredytu darmowego"
        ? "https://apidevkppp.ftpeople.pl/getWezwTaskSkd"
        : "https://apidevkppp.ftpeople.pl/getWezwTask",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        setTasksWezw(data[0]);
        fetchUsersSend5();
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const fetchUsersSend5 = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsersSend5", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsersSend5(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getPetitionerData = () => {
    var table =
      props.clientsData.petitioner.replaceAll("  ", "").split(",").length > 1
        ? props.clientsData.petitioner.replaceAll("  ", "").split(",")
        : props.clientsData.petitioner;

    var arr = [];

    if (isArray(table)) {
      table.map((el, index) => {
        arr.push({
          name: el,
          address: ", " + getAddress(el) + ", PESEL: " + getPesel(el),
        });
      });
      return arr;
    } else {
      return [
        {
          name: table,
          address: ", " + getAddress(table) + ", PESEL: " + getPesel(table),
        },
      ];
      //return table + ", " + getAddress(table) + ", PESEL: " + getPesel(table);
    }
  };

  const checkFree = (date) => {
    var blocks = freeDays.filter((el) => el.date === date);

    var bool = false;

    if (blocks.length > 0) {
      bool = true;
    } else {
      bool = false;
    }

    if (new Date(date).getDay() === 0 || new Date(date).getDay() === 6) {
      bool = true;
    }

    return bool;
  };

  const generateLastPayDate = () => {
    var date =
      props.clientsData.wezwLastPayDate === null ||
      props.clientsData.wezwLastPayDate === "całkowitej spłaty kredytu"
        ? ""
        : props.clientsData.wezwLastPayDate;

    if (date !== "") {
      date = date.replaceAll("r.", "");
      var dateA = date.split(" ");
      var day = dateA[0];
      var month = getMonthNumber(dateA[1]);
      var year = dateA[2];

      return year + "-" + month + "-" + day;
    } else {
      return date;
    }
  };

  const getData = async () => {
    fetchBankAddress();
  };

  useEffect(() => {
    getData();
  }, []);

  function loadFile(url, callback) {
    PizZipUtils.getBinaryContent(url, callback);
  }

  const getAddress = (el) => {
    var additionalData = props.clientsData.additionalData;
    if (additionalData === null) {
      return "";
    }
    var arr = additionalData.split("|");
    if (
      arr.filter(
        (x) => x.split(",")[0].replaceAll(" ", "") === el.replaceAll(" ", "")
      ).length > 0
    ) {
      return arr
        .filter(
          (x) => x.split(",")[0].replaceAll(" ", "") === el.replaceAll(" ", "")
        )[0]
        .split(",")[2]
        .replaceAll(";", ",");
    } else {
      return "";
    }
  };

  const getPesel = (el) => {
    var additionalData = props.clientsData.additionalData;
    if (additionalData === null) {
      return "";
    }
    var arr = additionalData.split("|");
    if (
      arr.filter(
        (x) => x.split(",")[0].replaceAll(" ", "") === el.replaceAll(" ", "")
      ).length > 0
    ) {
      return arr
        .filter(
          (x) => x.split(",")[0].replaceAll(" ", "") === el.replaceAll(" ", "")
        )[0]
        .split(",")[1];
    } else {
      return "";
    }
  };

  const generateClientName2 = () => {
    var table =
      props.clientsData.petitioner.replaceAll("  ", "").split(",").length > 1
        ? props.clientsData.petitioner.replaceAll("  ", "").split(",")
        : props.clientsData.petitioner;

    var arr = [];

    if (isArray(table)) {
      table.map((el, index) => {
        arr.push({
          name: el[0] === " " ? el.replace(" ", "") : el,
          address: ", " + getAddress(el) + ", PESEL: " + getPesel(el),
        });
      });
      return arr;
    } else {
      return [
        {
          name: table,
          address: ", " + getAddress(table) + ", PESEL: " + getPesel(table),
        },
      ];
      //return table + ", " + getAddress(table) + ", PESEL: " + getPesel(table);
    }
  };

  const generateClientName = () => {
    var table =
      props.clientsData.petitioner.split(",").length > 1
        ? props.clientsData.petitioner.replaceAll("  ", "").split(",")
        : props.clientsData.petitioner;
    var text = ``;

    if (isArray(table)) {
      table.map((el, index) => {
        text =
          text +
          (el[0] === " " ? el.replace(" ", "") : el) +
          (index + 1 === table.length ? "" : ", ");
      });
      return text.toString();
    } else {
      return table;
    }
  };

  const getMonthName = (month) => {
    if (month === 1) {
      return "stycznia";
    }
    if (month === 2) {
      return "lutego";
    }
    if (month === 3) {
      return "marca";
    }
    if (month === 4) {
      return "kwietnia";
    }
    if (month === 5) {
      return "maja";
    }
    if (month === 6) {
      return "czerwca";
    }
    if (month === 7) {
      return "lipca";
    }
    if (month === 8) {
      return "sierpnia";
    }
    if (month === 9) {
      return "września";
    }
    if (month === 10) {
      return "października";
    }
    if (month === 11) {
      return "listopada";
    }
    if (month === 12) {
      return "grudnia";
    }
  };

  const getMonthNumber = (month) => {
    if (month === "stycznia") {
      return "01";
    }
    if (month === "lutego") {
      return "02";
    }
    if (month === "marca") {
      return "03";
    }
    if (month === "kwietnia") {
      return "04";
    }
    if (month === "maja") {
      return "05";
    }
    if (month === "czerwca") {
      return "06";
    }
    if (month === "lipca") {
      return "07";
    }
    if (month === "sierpnia") {
      return "08";
    }
    if (month === "września") {
      return "09";
    }
    if (month === "października") {
      return "10";
    }
    if (month === "listopada") {
      return "11";
    }
    if (month === "grudnia") {
      return "12";
    }
  };

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, " ");
  };

  const checkDigit = (e) => {
    if (!/^\d*\,?\d*$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const validate = () => {
    if (dateOpt === "1") {
      if (lastPaymentDate.length <= 0) {
        return false;
      }
    }
    return true;
  };

  const addDayOne = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 1));
    return retDate;
  };

  const addDayThree = (date) => {
    var newDate = new Date(date);
    var retDate = new Date(newDate.setDate(newDate.getDate() + 3));
    return retDate;
  };

  const checkHoliday = (responsible, date) => {
    var final_date = new Date(date);
    var blocks = holidays.filter((el) => el.user === responsible);
    var bool = false;
    if (blocks.length === 0) {
      return bool;
    } else {
      blocks.map((el) => {
        if (
          (el.date_from >= final_date && el.date_from <= final_date) ||
          (final_date >= el.date_from && final_date <= el.date_to)
        ) {
          bool = true;
        }
      });
    }
    return bool;
  };

  const getBank = (bank) => {
    if (bank === "Raiffeisen Bank International AG") {
      return "Raiffeisen Bank International AG z siedzibą w Wiedniu działający przez Raiffeisen Bank International AG (Spółka Akcyjna) Oddział w Polsce";
    }
    if (bank === "PKO BP S.A.") {
      return "Powszechna Kasa Oszczędności Bank Polski S.A.";
    }
    if (bank === "PEKAO S.A.") {
      return "Bank Polska Kasa Opieki – Spółka Akcyjna";
    }
    return bank;
  };

  const generateDocument = async () => {
    if (!validate()) {
      MySwal.fire({
        icon: "error",
        title: "Uzupełnij",
        text: "wymagane pola formularza",
      }).then(async (result) => {});
      return;
    }
    loadFile(template, function (error, content) {
      if (error) {
        throw error;
      }
      var zip = new PizZip(content);
      var doc = new Docxtemplater(zip, {
        paragraphLoop: true,
        linebreaks: true,
      });
      var bankTr = getBank(
        bankAddressDb === undefined
          ? "(uzupełnij)"
          : bankAddressDb.nameLetter === undefined
          ? ""
          : bankAddressDb.nameLetter
      );
      var bankTr2 = getBank(bankAddressDb.nameLetter);
      var plnValueTr =
        +plnValue.toString().replaceAll(" ", "").replaceAll(",", ".") > 0
          ? numberWithCommas(plnValue)
          : "";
      var plnTextTr =
        +plnValue.toString().replaceAll(" ", "").replaceAll(",", ".") > 0
          ? " zł"
          : "";
      var chfValueTr = numberWithCommas(chfValue);
      var lastPaymentDateTr =
        dateOpt === "1"
          ? (new Date(lastPaymentDate).getDate() < 10
              ? "0" + new Date(lastPaymentDate).getDate()
              : new Date(lastPaymentDate).getDate()) +
            " " +
            getMonthName(new Date(lastPaymentDate).getMonth() + 1) +
            " " +
            new Date(lastPaymentDate).getFullYear() +
            " r."
          : "całkowitej spłaty kredytu";
      var payTimeTr = payTime;

      doc.setData({
        date:
          (new Date().getDate() < 10
            ? "0" + new Date().getDate()
            : new Date().getDate()) +
          " " +
          getMonthName(new Date().getMonth() + 1) +
          " " +
          new Date().getFullYear() +
          " r.",
        bankSimple: bankTr,
        bank_address:
          bankAddressDb === undefined ? "(uzupełnij)" : bankAddressDb.address,
        hasManyPet: getPetitionerData().length > 1 ? true : false,
        hasNManyPet: getPetitionerData().length === 1 ? true : false,
        petitioner: generateClientName().replaceAll("  ", ""),
        petitioner_data2: generateClientName2(),
        plnValue: plnValueTr,
        plnText: plnTextTr,
        bank: bankTr,
        bank2: bankTr2,
        chfValue:
          +chfValue !== undefined
            ? +chfValue.toString().replaceAll(" ", "").replaceAll(",", ".") > 0
              ? chfValueTr + " CHF"
              : ""
            : "",
        chfText:
          +chfValue !== undefined
            ? +chfValue.toString().replaceAll(" ", "").replaceAll(",", ".") >
                0 &&
              +plnValue.toString().replaceAll(" ", "").replaceAll(",", ".") > 0
              ? " oraz "
              : ""
            : "",
        paymentDate: lastPaymentDateTr,
        knadPLN: props.clientsData.nadPLN
          ? numberWithCommas(parseFloat(props.clientsData.nadPLN)) + " PLN"
          : "",
        knadCHF: props.clientsData.nadCHF
          ? numberWithCommas(parseFloat(props.clientsData.nadCHF)) + " CHF"
          : "",
        creditNumber:
          props.clientsData.credit_aggr_num === ""
            ? "<uzupełnij>"
            : props.clientsData.credit_aggr_num,
        creditDate:
          props.clientsData.credit_date === ""
            ? "<uzupełnij>"
            : (new Date(props.clientsData.credit_date).getDate() < 10
                ? "0" + new Date(props.clientsData.credit_date).getDate()
                : new Date(props.clientsData.credit_date).getDate()) +
              " " +
              getMonthName(
                new Date(props.clientsData.credit_date).getMonth() + 1
              ) +
              " " +
              new Date(props.clientsData.credit_date).getFullYear() +
              " r.",
        payTime: payTimeTr,
        bank_krs: bankAddressDb ? bankAddressDb.bankKRS : "uzupełnij",
        zast_text:
          props.clientsData.petitioner.replaceAll("  ", "").split(",").length >
          1
            ? "zastępowani"
            : "zastępowany",
        pettioner_details:
          "telefon: " +
          props.clientsData.phone +
          ", adres e-mail: " +
          props.clientsData.email,
      });
      try {
        doc.render();
      } catch (error) {
        function replaceErrors(key, value) {
          if (value instanceof Error) {
            return Object.getOwnPropertyNames(value).reduce(function (
              error,
              key
            ) {
              error[key] = value[key];
              return error;
            },
            {});
          }
          return value;
        }

        if (error.properties && error.properties.errors instanceof Array) {
          const errorMessages = error.properties.errors
            .map(function (error) {
              return error.properties.explanation;
            })
            .join("\n");
        }
        throw error;
      }
      var out = doc.getZip().generate({
        type: "blob",
        mimeType:
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
      saveAs(
        out,
        getTemplateName(template) + "_" + props.clientsData.petitioner
      );

      var bodyX = {
        clientId: props.clientsData.id,
        wezwPlnValue: numberWithCommas(plnValueTr),
        wezwChfValue: numberWithCommas(chfValueTr),
        wezwLastPayDate: lastPaymentDateTr,
        wezwPayTime: payTimeTr,
        koSkd: numberWithCommas(koSkd),
        izrSkd: numberWithCommas(izrSkd),
        irSkd: irSkd,
        kpSkd: numberWithCommas(kpSkd),
        kupSkd: numberWithCommas(kupSkd),
      };

      fetch("https://apidevkppp.ftpeople.pl/updateWezwData", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(bodyX),
      })
        .then((response) => {})
        .then((responseJson) => {});

      MySwal.fire({
        title: "Czy chcesz zapisać pismo w systemie?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Tak",
        denyButtonText: `Nie`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          let formData = new FormData();
          formData.append("file", out);
          formData.append("type", "auto");
          formData.append("clientId", props.clientsData.id);
          formData.append("taskId", "");
          formData.append("user", props.userName);
          formData.append(
            "name",
            getTemplateName(template) + "_" + props.clientsData.petitioner
          );

          await fetch("https://apidevkppp.ftpeople.pl/uploadFileAutoPDF", {
            method: "POST",
            body: formData,
          })
            .then((response) => {
              addTask();
            })
            .then((responseJson) => {});
        } else if (result.isDenied) {
          addTask();
        }
      });
    });
  };

  const addTask = () => {
    MySwal.fire({
      title: "Czy chcesz oznaczyć zadanie 'Wezwanie do zapłaty' jako wykonane?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        var body = {
          id: props.clientsData.id,
        };

        await fetch(
          props.clientsData.type === "sankcja kredytu darmowego"
            ? "https://apidevkppp.ftpeople.pl/doWezwTaskSkd"
            : "https://apidevkppp.ftpeople.pl/doWezwTask",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body),
          }
        )
          .then((response) => response.text())
          .then((data) => {
            setSprWezw();
          })
          .catch((error) => {
            setSprWezw();
          });
      } else if (result.isDenied) {
        try {
          if (tasksWezw) {
            if (tasksWezw.postNumber.length > 0) {
              props.close();
            } else {
              addPostDialog();
            }
          } else {
            addPostDialog();
          }
        } catch (err) {
          addPostDialog();
        }
      }
    });
  };

  function getNextFriday(date) {
    const dateCopy = new Date(date.getTime());

    const nextFriday = new Date(
      dateCopy.setDate(
        dateCopy.getDate() + ((7 - dateCopy.getDay() + 5) % 7 || 7)
      )
    );

    return nextFriday;
  }

  const setValue = () => {};

  const setSprWezw = () => {
    var task = props.tasksList.filter(
      (el) =>
        el.task === "Sprawdzenie wezwania do zapłaty" ||
        el.task === "Opłata od pozwu – wysłać dane do klienta"
    );
    if (task.length > 0) {
      //addPost();
      //return;
    }
    var model = [];

    if (props.team === 0) {
      lawyersData.map((element) => {
        model[element.name] = element.name;
      });
    } else {
      lawyersData
        .filter((el) => el.team.includes(props.team))
        .map((element) => {
          model[element.name] = element.name;
        });
    }

    MySwal.fire({
      title: "Kto ma sprawdzić wezwanie do zapłaty?",
      input: "select",
      inputOptions: model,
      inputPlaceholder: "wybierz pracownika",
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz wybrać pracownika");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var responsibleA = result.value;
        if (props.clientsData.type === "sankcja kredytu darmowego") {
          MySwal.fire({
            title: "Proszę podać wysokość opłaty sądowej od pozwu",
            html: `
            <input id="swal-input1" type="number" class="swal2-input" onkeypress="return event.charCode >= 48 && event.charCode <= 57">
          `,
            showCancelButton: true,
            cancelButtonText: "Anuluj",
            preConfirm: () => {
              return document.getElementById("swal-input1").value;
            },
          }).then(async function (resultX) {
            var value = resultX.value;
            var bodyX = {
              id: props.clientsData.id,
              value: value,
            };

            fetch("https://apidevkppp.ftpeople.pl/updateOpSp", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(bodyX),
            })
              .then((response) => response.text())
              .then(async (responseJson) => {
                var date_startA =
                  new Date().getFullYear() +
                  "-" +
                  (new Date().getMonth() + 1) +
                  "-" +
                  new Date().getDate();

                var newFinalDate = addDayThree(new Date());
                if (newFinalDate.getDay() === 0) {
                  newFinalDate = new Date(
                    newFinalDate.setDate(newFinalDate.getDate() + 1)
                  );
                }
                if (newFinalDate.getDay() === 6) {
                  newFinalDate = new Date(
                    newFinalDate.setDate(newFinalDate.getDate() + 2)
                  );
                }

                var date_final = newFinalDate;

                while (
                  (checkFree(date_final) ||
                    checkHoliday(responsibleA, date_final)) &&
                  (date_final.getDay() === 0 || date_final.getDay() === 6)
                ) {
                  date_final = addDayOne(date_final);
                }

                var dateFinal =
                  date_final.getFullYear() +
                  "-" +
                  (date_final.getMonth() + 1) +
                  "-" +
                  date_final.getDate();

                var body3 = {
                  responsible: responsibleA,
                  start_date: date_startA,
                  final_date: dateFinal,
                  bank: props.clientsData.bank,
                  sygn: props.clientsData.aSygn,
                  client_name: props.clientsData.petitioner,
                  task: "Sprawdzenie wezwanie do zapłaty",
                  date_added: new Date(),
                  user_added: props.userName,
                  status: "ZLECONE",
                  court: props.clientsData.aCourt,
                  type: "POZASĄDOWE",
                  readed: "no",
                  addRole: "user",
                  cycleId: "",
                  clientId: props.clientsData.id,
                  task_conn: "c",
                  team: props.clientsData.team,
                  note: "",
                };

                await fetch("https://apidevkppp.ftpeople.pl/insertTaskFull", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: secretKey,
                  },
                  body: JSON.stringify(body3),
                })
                  .then((response) => response.text())
                  .then(async (data) => {
                    var date_start =
                      new Date().getFullYear() +
                      "-" +
                      (new Date().getMonth() + 1) +
                      "-" +
                      new Date().getDate();
                    var dateFinal = new Date();

                    var newFinalDate = getNextFriday(new Date());
                    if (newFinalDate.getDay() === 0) {
                      newFinalDate = new Date(
                        newFinalDate.setDate(newFinalDate.getDate() + 1)
                      );
                    }
                    if (newFinalDate.getDay() === 6) {
                      newFinalDate = new Date(
                        newFinalDate.setDate(newFinalDate.getDate() + 2)
                      );
                    }

                    var date_final = newFinalDate;

                    while (
                      (checkFree(date_final) ||
                        checkHoliday("Marta Kurzyk", date_final)) &&
                      (date_final.getDay() === 0 || date_final.getDay() === 6)
                    ) {
                      date_final = addDayOne(date_final);
                    }

                    dateFinal =
                      date_final.getFullYear() +
                      "-" +
                      (date_final.getMonth() + 1) +
                      "-" +
                      date_final.getDate();

                    var body2 = {
                      responsible:
                        +props.clientsData.team === 1
                          ? usersSend5.filter((el) => +el.team === 1)[0].user
                          : usersSend5.filter((el) => +el.team === 2)[0].user,
                      start_date: date_start,
                      final_date: dateFinal,
                      bank: props.clientsData.bank,
                      sygn: props.clientsData.aSygn,
                      client_name: props.clientsData.petitioner,
                      task: "Opłata od pozwu – wysłać dane do klienta",
                      date_added: new Date(),
                      user_added: props.userName,
                      status: "ZLECONE",
                      court: props.clientsData.aCourt,
                      type: "POZASĄDOWE",
                      readed: "no",
                      addRole: "user",
                      cycleId: "",
                      clientId: props.clientsData.id,
                      task_conn: "c",
                      team: props.clientsData.team,
                      note: "",
                    };

                    await fetch(
                      "https://apidevkppp.ftpeople.pl/insertTaskFull",
                      {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                          Authorization: secretKey,
                        },
                        body: JSON.stringify(body2),
                      }
                    )
                      .then((response) => response.text())
                      .then(async (data) => {
                        var body5 = {
                          id: props.clientsData.id,
                          data_wezw:
                            new Date().getFullYear() +
                            "-" +
                            (new Date().getMonth() + 1 < 10
                              ? "0" + (new Date().getMonth() + 1)
                              : new Date().getMonth() + 1) +
                            "-" +
                            (new Date().getDate() < 10
                              ? "0" + new Date().getDate()
                              : new Date().getDate()),
                        };

                        await fetch(
                          "https://apidevkppp.ftpeople.pl/addDWClient",
                          {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                              Authorization: secretKey,
                            },
                            body: JSON.stringify(body5),
                          }
                        )
                          .then((response) => response.text())
                          .then((data) => {
                            addPost();
                            return;
                          })
                          .catch((error) => {});
                      })
                      .catch((error) => {});
                  })
                  .catch((error) => {});
              });
          });
        } else {
          var date_startA =
            new Date().getFullYear() +
            "-" +
            (new Date().getMonth() + 1) +
            "-" +
            new Date().getDate();

          var newFinalDate = addDayThree(new Date());
          if (newFinalDate.getDay() === 0) {
            newFinalDate = new Date(
              newFinalDate.setDate(newFinalDate.getDate() + 1)
            );
          }
          if (newFinalDate.getDay() === 6) {
            newFinalDate = new Date(
              newFinalDate.setDate(newFinalDate.getDate() + 2)
            );
          }

          var date_final = newFinalDate;

          while (
            (checkFree(date_final) || checkHoliday(responsibleA, date_final)) &&
            (date_final.getDay() === 0 || date_final.getDay() === 6)
          ) {
            date_final = addDayOne(date_final);
          }

          var dateFinal =
            date_final.getFullYear() +
            "-" +
            (date_final.getMonth() + 1) +
            "-" +
            date_final.getDate();

          var body3 = {
            responsible: responsibleA,
            start_date: date_startA,
            final_date: dateFinal,
            bank: props.clientsData.bank,
            sygn: props.clientsData.aSygn,
            client_name: props.clientsData.petitioner,
            task: "Sprawdzenie wezwanie do zapłaty",
            date_added: new Date(),
            user_added: props.userName,
            status: "ZLECONE",
            court: props.clientsData.aCourt,
            type: "POZASĄDOWE",
            readed: "no",
            addRole: "user",
            cycleId: "",
            clientId: props.clientsData.id,
            task_conn: "c",
            team: props.clientsData.team,
            note: "",
          };

          await fetch("https://apidevkppp.ftpeople.pl/insertTaskFull", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body3),
          })
            .then((response) => response.text())
            .then(async (data) => {
              var date_start =
                new Date().getFullYear() +
                "-" +
                (new Date().getMonth() + 1) +
                "-" +
                new Date().getDate();
              var dateFinal = new Date();

              var newFinalDate = getNextFriday(new Date());
              if (newFinalDate.getDay() === 0) {
                newFinalDate = new Date(
                  newFinalDate.setDate(newFinalDate.getDate() + 1)
                );
              }
              if (newFinalDate.getDay() === 6) {
                newFinalDate = new Date(
                  newFinalDate.setDate(newFinalDate.getDate() + 2)
                );
              }

              var date_final = newFinalDate;

              while (
                (checkFree(date_final) ||
                  checkHoliday("Marta Kurzyk", date_final)) &&
                (date_final.getDay() === 0 || date_final.getDay() === 6)
              ) {
                date_final = addDayOne(date_final);
              }

              dateFinal =
                date_final.getFullYear() +
                "-" +
                (date_final.getMonth() + 1) +
                "-" +
                date_final.getDate();

              var body2 = {
                responsible:
                  +props.clientsData.team === 1
                    ? usersSend5.filter((el) => +el.team === 1)[0].user
                    : usersSend5.filter((el) => +el.team === 2)[0].user,
                start_date: date_start,
                final_date: dateFinal,
                bank: props.clientsData.bank,
                sygn: props.clientsData.aSygn,
                client_name: props.clientsData.petitioner,
                task: "Opłata od pozwu – wysłać dane do klienta",
                date_added: new Date(),
                user_added: props.userName,
                status: "ZLECONE",
                court: props.clientsData.aCourt,
                type: "POZASĄDOWE",
                readed: "no",
                addRole: "user",
                cycleId: "",
                clientId: props.clientsData.id,
                task_conn: "c",
                team: props.clientsData.team,
                note: "",
              };

              await fetch("https://apidevkppp.ftpeople.pl/insertTaskFull", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: secretKey,
                },
                body: JSON.stringify(body2),
              })
                .then((response) => response.text())
                .then(async (data) => {
                  var body5 = {
                    id: props.clientsData.id,
                    data_wezw:
                      new Date().getFullYear() +
                      "-" +
                      (new Date().getMonth() + 1 < 10
                        ? "0" + (new Date().getMonth() + 1)
                        : new Date().getMonth() + 1) +
                      "-" +
                      (new Date().getDate() < 10
                        ? "0" + new Date().getDate()
                        : new Date().getDate()),
                  };

                  await fetch("https://apidevkppp.ftpeople.pl/addDWClient", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: secretKey,
                    },
                    body: JSON.stringify(body5),
                  })
                    .then((response) => response.text())
                    .then((data) => {
                      addPost();
                      return;
                    })
                    .catch((error) => {});
                })
                .catch((error) => {});
            })
            .catch((error) => {});
        }
      }
      if (result.isDenied) {
        addPostDialog();
      }
    });
  };

  const addPostDialog = () => {
    addPost();
  };

  const addPost = () => {
    MySwal.fire({
      title: "Czy chcesz dodać adresata do książki nadawczej?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setShowSendPost(true);
      } else if (result.isDenied) {
        props.close();
      }
    });
  };

  const getTemplateName = (value) => {
    var name = letters.filter((el) => el.link === value);
    if (name.length > 0) {
      setTask(name[0].task);
      return name[0].name;
    } else {
      setTask("inne");
      return "nie znaleziono";
    }

    if (value === "./asd20.docx") {
      setTask("Wezwanie do zapłaty");
      return "Wezwanie do zapłaty";
    }
    if (value === "./asd48.docx") {
      setTask("Wezwanie do zapłaty SKD");
      return "Wezwanie do zapłaty SDK";
    }
    if (value === "./asd49.docx") {
      setTask("Wezwanie do zapłaty z oświadczeniem SKD");
      return "Wezwanie do zapłaty z oświadczeniem SKD";
    }
  };

  const handleTemplateChange = (e) => {
    var value = e.target.value;
    var name = letters.filter((el) => el.link === value);
    if (name.length > 0) {
      setTask(name[0].task);
      setTemplate(name[0].link);
    } else {
      setTask("inne");
      setTemplate(null);
    }

    return;

    if (value === "./asd20.docx") {
      setTask("Wezwanie do zapłaty");
    }

    if (value === "./asd48.docx") {
      setTask("Wezwanie do zapłaty SKD");
    }

    if (value === "./asd49.docx") {
      setTask("Wezwanie do zapłaty z oświadczeniem SKD");
    }

    setTemplate(e.target.value);
  };

  const setDateOptF = (e) => {
    setDateOpt(e.target.value);
    if (e.target.value === "1") {
      setLastPaymentDate("");
    } else {
      setLastPaymentDate("całkowitej spłaty kredytu");
    }
  };

  const closeSendPost = () => {
    setShowSendPost(false);
    addPost();
  };

  return (
    <div
      style={{ width: "50vw", top: "5vh" }}
      className="mainContainerAddClientContact"
    >
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div className="closeBox">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>
          {showSendPost ? (
            <>
              <SendPostTask
                close={closeSendPost}
                client={props.clientsData}
                task={tasksWezw ? tasksWezw : null}
              />
            </>
          ) : (
            ""
          )}
          <div
            id="addPaymentIC"
            className="inputContainer"
            style={{ height: "70vh", overflowY: "scroll" }}
          >
            <div className="inputBox">
              <div className="inputCol_1">
                <label>
                  Wybierz szablon <span className="requiredStar">*</span>
                </label>
                <select
                  type="text"
                  id="court"
                  name="court"
                  value={template}
                  onChange={handleTemplateChange}
                >
                  {template === "" ? (
                    <option key={0} value={""}>
                      {"Wybierz..."}
                    </option>
                  ) : (
                    ""
                  )}
                  {letters.map((el) => (
                    <option key={el.id} name={el.name} value={el.link}>
                      {el.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {template ? (
              <>
                <div id="addPaymentIC" className="inputContainer">
                  <div className="inputBox">
                    <div style={{ minWidth: "49%" }} className="inputCol_2">
                      <label>
                        Kwota w PLN <span className="requiredStar">*</span>
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={plnValue}
                        onChange={(e) => {
                          setPlnValue(e.target.value);
                        }}
                        onKeyPress={checkDigit}
                      />
                    </div>
                    {letters.filter((el) => el.link === template).length > 0 ? (
                      letters.filter((el) => el.link === template)[0].type ===
                      "CHF" ? (
                        <>
                          <div
                            style={{ minWidth: "49%" }}
                            className="inputCol_2"
                          >
                            <label>Kwota w CHF</label>
                            <input
                              type="text"
                              id="name"
                              name="name"
                              value={chfValue}
                              onChange={(e) => {
                                setChfValue(e.target.value);
                              }}
                              onKeyPress={checkDigit}
                            />
                          </div>
                        </>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="inputBox">
                    <div style={{ minWidth: "49%" }} className="inputCol_2">
                      <label>
                        Data ostatniej wpłaty{" "}
                        <span className="requiredStar">*</span>
                      </label>
                      <div style={{ marginTop: "20px" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <input
                            style={{
                              width: "20px",
                              margin: "0",
                              height: "2vh",
                              boxShadow: "none",
                            }}
                            type="radio"
                            value="1"
                            checked={dateOpt === "1" ? true : false}
                            name="gender"
                            onChange={setDateOptF}
                          />{" "}
                          Data z kalendarza
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            marginTop: "5px",
                          }}
                        >
                          <input
                            style={{
                              width: "20px",
                              margin: "0",
                              height: "2vh",
                              boxShadow: "none",
                            }}
                            type="radio"
                            value="2"
                            checked={dateOpt === "2" ? true : false}
                            name="gender"
                            onChange={setDateOptF}
                          />
                          Całkowita spłata kredytu
                        </div>
                      </div>
                    </div>
                    {dateOpt === "1" ? (
                      <>
                        <div
                          style={{
                            minWidth: "49%",
                            display: "flex",
                            alignItems: "center",
                          }}
                          className="inputCol_2"
                        >
                          <input
                            type="date"
                            id="name"
                            name="name"
                            value={lastPaymentDate}
                            onChange={(e) => {
                              setLastPaymentDate(e.target.value);
                            }}
                          />
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="inputBox">
                    <div style={{ minWidth: "49%" }} className="inputCol_2">
                      <label>
                        Termin płatności <span className="requiredStar">*</span>
                      </label>
                      <div style={{ marginTop: "20px" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <input
                            style={{
                              width: "20px",
                              margin: "0",
                              height: "2vh",
                              boxShadow: "none",
                            }}
                            type="radio"
                            value="3 dni"
                            checked={payTime === "3 dni" ? true : false}
                            name="payTime"
                            onChange={(e) => setPayTime(e.target.value)}
                          />{" "}
                          3 dni
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            marginTop: "5px",
                          }}
                        >
                          <input
                            style={{
                              width: "20px",
                              margin: "0",
                              height: "2vh",
                              boxShadow: "none",
                            }}
                            type="radio"
                            value="7 dni"
                            checked={payTime === "7 dni" ? true : false}
                            name="payTime"
                            onChange={(e) => setPayTime(e.target.value)}
                          />{" "}
                          7 dni
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            marginTop: "5px",
                          }}
                        >
                          <input
                            style={{
                              width: "20px",
                              margin: "0",
                              height: "2vh",
                              boxShadow: "none",
                            }}
                            type="radio"
                            value="14 dni"
                            checked={payTime === "14 dni" ? true : false}
                            name="payTime"
                            onChange={(e) => setPayTime(e.target.value)}
                          />{" "}
                          14 dni
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}
            {letters.filter((el) => el.link === template).length > 0 ? (
              letters.filter((el) => el.link === template)[0].type === "SKD" ? (
                <>
                  <div className="inputBox">
                    <div style={{ minWidth: "90%" }} className="inputCol_1">
                      <label>Kwota odsetek</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={koSkd}
                        onChange={(e) => {
                          setKoSkd(e.target.value);
                        }}
                        onKeyPress={checkDigit}
                      />
                    </div>
                  </div>
                  <div className="inputBox">
                    <div style={{ minWidth: "90%" }} className="inputCol_1">
                      <label>Ilość zapłaconych rat</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={izrSkd}
                        onChange={(e) => {
                          setIzrSkd(e.target.value);
                        }}
                        onKeyPress={checkDigit}
                      />
                    </div>
                  </div>
                  <div className="inputBox">
                    <div style={{ minWidth: "90%" }} className="inputCol_1">
                      <label>Ilość rat</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={irSkd}
                        onChange={(e) => {
                          setIrSkd(e.target.value);
                        }}
                        onKeyPress={checkDigit}
                      />
                    </div>
                  </div>
                  <div className="inputBox">
                    <div style={{ minWidth: "90%" }} className="inputCol_1">
                      <label>Kwota prowizji</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={kpSkd}
                        onChange={(e) => {
                          setKpSkd(e.target.value.replaceAll(",", "."));
                          if (
                            izrSkd.replaceAll(" ", "").replaceAll(",", ".") >
                              0 &&
                            irSkd.replaceAll(" ", "").replaceAll(",", ".") > 0
                          ) {
                            setKupSkd(
                              Number(
                                (izrSkd
                                  .replaceAll(" ", "")
                                  .replaceAll(".", ",") /
                                  irSkd
                                    .replaceAll(" ", "")
                                    .replaceAll(".", ",")) *
                                  e.target.value.replaceAll(",", ".")
                              ).toFixed(2)
                            );

                            setPlnValue(
                              Number(
                                (izrSkd / irSkd) *
                                  +e.target.value.replaceAll(",", ".") +
                                  +koSkd.replaceAll(",", ".")
                              ).toFixed(2)
                            );
                          }
                        }}
                        onKeyPress={checkDigit}
                      />
                    </div>
                  </div>
                  <div className="inputBox">
                    <div style={{ minWidth: "90%" }} className="inputCol_1">
                      <label>Kwota uiszczonej prowizji</label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={kupSkd}
                        onChange={(e) => {
                          setKupSkd(e.target.value);
                        }}
                        onKeyPress={checkDigit}
                      />
                    </div>
                  </div>
                </>
              ) : (
                ""
              )
            ) : (
              ""
            )}

            <div className="saveBoxAP">
              <button className="paymentMenuButton" onClick={generateDocument}>
                Wygeneruj
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AddLetterBank;
